var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: "emailSettingsAccountModeTransfer",
        staticClass: "flex-row jc-space ai-center p-3 bt-1 transfert_email"
      },
      [
        _c("div", { staticClass: "flex-column left" }, [
          _c("div", { staticClass: "typographies-paragraph-medium-bold" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$t.__(
                    "email.EmailSettingsAccountModeTransfer.transfer_email"
                  )
                ) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n                " +
                _vm._s("corp" + _vm.corpId + "s" + _vm.userId + "@sellsy.net") +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "transfert_email-caption-help-link typographies-heading-h4"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t.__(
                      "email.EmailSettingsAccountModeTransfer.connect_an_account"
                    )
                  ) +
                  "\n\n                "
              ),
              _c("CompassLink", {
                attrs: { label: _vm.$t.__("common.labels.learn_more") }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.isAdmin || !_vm.isEmailsSentFromCorp
          ? _c(
              "router-link",
              { attrs: { to: { name: "onboarding.email" } } },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("email.configure_email_service"),
                    type: _vm.isOnboardingSetup ? "secondary" : "primary"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "p-3 bt-1 sending-email" }, [
      _c(
        "div",
        { staticClass: "wp-10" },
        [
          _c(
            "p",
            { staticClass: "typographies-paragraph-medium-bold mb-1 mt-0" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t.__(
                      "email.EmailSettingsAccountModeTransfer.sending_adress_email"
                    )
                  ) +
                  "\n            "
              )
            ]
          ),
          _vm._v(" "),
          !_vm.emailIsVerified && (_vm.isAdmin || !_vm.isEmailsSentFromCorp)
            ? _c("CompassAlert", {
                attrs: {
                  type: "warning",
                  showClose: false,
                  description: _vm.$t.__(
                    "email.EmailSettingsAccountModeTransfer.confirm_email_adress"
                  ),
                  action: {
                    label: _vm.$t.__(
                      "email.EmailSettingsAccountModeTransfer.check_now"
                    ),
                    callback: function() {
                      return _vm.openPopupCheckSendingEmail("checking")
                    }
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-level mt-2" }, [
        _c(
          "div",
          { staticClass: "typographies-paragraph-medium-regular wp-6" },
          [_vm._v(_vm._s(_vm.textSenderEmail))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wp-3 flex-item-right" },
          [
            _c(
              "div",
              {
                staticClass: "flex-row ai-center",
                staticStyle: { "justify-content": "end" }
              },
              [
                !_vm.emailIsVerified
                  ? _c(
                      "div",
                      { staticClass: "no-shrink mr-2" },
                      [
                        _c("CompassIcon", {
                          attrs: { icon: "warning-fill", type: "warning" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      content: _vm.$t.__(
                        "email.EmailSettingsAccountModeTransfer.pending_verification"
                      ),
                      disabled: !_vm.shouldDisplayTooltip
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "typographies-paragraph-medium-regular" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.senderEmail) +
                            "\n                        "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    disabled: !_vm.isAdmin && _vm.isEmailsSentFromCorp,
                    label: _vm.$t.__("common.actions.edit"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.openPopupCheckSendingEmail("edit")
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("el-input", {
              attrs: { name: "senderEmail", type: "hidden" },
              model: {
                value: _vm.newSenderEmail,
                callback: function($$v) {
                  _vm.newSenderEmail = $$v
                },
                expression: "newSenderEmail"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isPendingEmail && !_vm.isPendingEmailVerificationOnActualSender
        ? _c(
            "div",
            { staticClass: "flex-row mt-2 flex-right" },
            [
              _c("CompassIcon", {
                attrs: { icon: "warning-fill", size: "small", type: "warning" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "checkingEmailPendingMessage",
                  staticClass:
                    "typographies-paragraph-small-regular gray-80 ml-1"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.pendingMessage) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSavingEmailNeeded
        ? _c(
            "div",
            { staticClass: "flex-row mt-2 flex-right" },
            [
              _c("CompassIcon", {
                attrs: { icon: "warning-fill", size: "small", type: "warning" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "sendingEmailShowSaveNeededMessage",
                  staticClass:
                    "typographies-paragraph-small-regular aright gray-80 ml-1"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t.__(
                          "email.EmailSettingsAccountModeTransfer.save_preferences",
                          _vm.newSenderEmail
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isActiveDomainSection
      ? _c("div", { staticClass: "flex-level p-3 bt-1" }, [
          _c("div", { staticClass: "wp-6" }, [
            _c("p", { staticClass: "bold mb-1 mt-0" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t.__(
                      "email.EmailSettingsAccountModeTransfer.status_of_my_domain"
                    )
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "grey my-0 mr-1" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t.__(
                      "email.EmailSettingsAccountModeTransfer.authenticated_and_properly_configured_domain"
                    )
                  ) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-0 mt-1" }, [
              _c(
                "a",
                {
                  staticClass: "link mb-0 mt-0 fs-3",
                  attrs: {
                    href:
                      "https://help.sellsy.com/hc/receiving-and-sending-emails-with-sellsy/set-up-your-domain-for-better-deliverability?searched=true",
                    target: "_blank"
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t.__(
                          "email.EmailSettingsAccountModeTransfer.help_with_domain_authentication"
                        )
                      ) +
                      "\n                "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "wp-4 flex-row jc-space" },
            [
              _c("div", { staticClass: "ml-6" }, [
                _c("p", { staticClass: "grey m-0" }, [
                  _vm._v(_vm._s(_vm.$t.__("common.labels.status")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "m-0" }, [
                  _c("span", {
                    staticClass: "chip",
                    class: "chip-" + _vm.domainStatus.type
                  }),
                  _vm._v(
                    _vm._s(_vm.domainStatus.message) + "\n                "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__(
                    "email.EmailSettingsAccountModeTransfer.authenticate_domain"
                  ),
                  type: "secondary"
                },
                on: { click: _vm.goToSettingsEmailDomain }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }